function initQuantitySelector() {
  class QuantitySelector extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        qtyInput: '[data-qty-input]',
        incrementBtn: '[data-increment-qty]',
        decrementBtn: '[data-decrement-qty]',
        qtyError: '[data-qty-error]',
      };

      this.classes = {
        hide: 'hide',
      };

      this.qtyInput = this.querySelector(this.selectors.qtyInput);
      this.decrementBtn = this.querySelector(this.selectors.decrementBtn);
      this.incrementBtn = this.querySelector(this.selectors.incrementBtn);
      this.qtyError = this.parentNode?.querySelector(this.selectors.qtyError);

      this.qtyMin = this.qtyInput?.getAttribute('min') ? Number(this.qtyInput.getAttribute('min')) : 1;
      this.qtyMax = this.qtyInput?.getAttribute('max') ? Number(this.qtyInput.getAttribute('max')) : null;
      this.qtyIncrement = this.qtyInput?.getAttribute('step') ? Number(this.qtyInput.getAttribute('step')) : 1;

      // Handle click on increment buttons
      this.incrementBtn?.addEventListener('click', () => {
        if (!this.qtyInput) return;

        const newQty = Number(this.qtyInput.value) + this.qtyIncrement;
        this.qtyInput.value = newQty;

        this.handleButtonsDisableState(newQty);
      });

      // Handle click on decrement button
      if (this.decrementBtn) {
        this.decrementBtn.disabled = true;

        this.decrementBtn.addEventListener('click', () => {
          if (!this.qtyInput) return;

          const newQty = Number(this.qtyInput.value) - this.qtyIncrement;
          if (newQty <= 0) return;

          this.qtyInput.value = Number(newQty);

          this.handleButtonsDisableState(newQty);
        });
      }

      // Handle manual quantity input
      this.qtyInput?.addEventListener('change', () => {
        const inputValue = Number(this.qtyInput.value);

        const isValidQuantity = inputValue % this.qtyIncrement === 0;

        let validationType = null;

        if (inputValue < this.qtyMin) {
          this.qtyInput.value = this.qtyMin;
          validationType = 'min';
        } else if (this.qtyMax && inputValue > this.qtyMax) {
          this.qtyInput.value = this.qtyMax;
          validationType = 'max';
        } else if (!isValidQuantity) {
          // Get the nearest valid quantity, and check against min and max values
          let validQty = Math.round(inputValue / this.qtyIncrement) * this.qtyIncrement;
          if (this.qtyMax) {
            validQty = Math.min(validQty, this.qtyMax);
          }
          const newQty = Math.max(this.qtyMin, validQty);
          this.qtyInput.value = newQty;

          validationType = 'increment';
        }

        this.handleButtonsDisableState(this.qtyInput.value);
        this.handleErrorDisplay(validationType);
      });
    }

    handleButtonsDisableState(qty) {
      this.decrementBtn.disabled = this.qtyMin && qty <= this.qtyMin;
      this.incrementBtn.disabled = this.qtyMax && (qty >= this.qtyMax || qty + this.qtyIncrement > this.qtyMax);
    }

    handleErrorDisplay(type) {
      if (!this.qtyError) return;

      let errorMessage = null;

      if (type === 'min') {
        // show minimum quantity reached error
        errorMessage = window.theme?.strings?.qtyMinError?.replace('{{ quantity }}', this.qtyMin);
      } else if (type === 'max') {
        // show maximum quantity reached error
        errorMessage = window.theme?.strings?.qtyMaxError?.replace('{{ quantity }}', this.qtyMax);
      } else if (type === 'increment') {
        // show increment of error
        errorMessage = window.theme?.strings?.qtyIncrementError?.replace('{{ quantity }}', this.qtyIncrement);
      }

      if (errorMessage) {
        this.qtyError.innerHTML = errorMessage;
        this.qtyError.classList.remove(this.classes.hide);
        return;
      }

      this.qtyError.classList.add(this.classes.hide);
      this.qtyError.innerHTML = '';
    }
  }

  customElements.define('quantity-selector', QuantitySelector);
}

export default initQuantitySelector;
